import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Reveal } from "../motion/Reveal";
import { CircledArrow } from "../brand/icons";

export const LatestEditionBanner = () => {
  const [edition, setEdition] = useState(undefined);
  const saveData = typeof navigator !== "undefined" && navigator.connection && navigator.connection.saveData;
  const reduceMotion = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    api
      .get("/editions/latest")
      .then((res) => setEdition(res.data))
      .catch(() => setEdition(null));
  }, []);

  if (!edition) return null;

  const showVideo = edition.media_type === "video" && edition.video && !saveData && !reduceMotion;

  return (
    <section
      data-testid="latest-edition-banner"
      className="relative flex items-end overflow-hidden bg-charcoal text-offwhite"
      style={{ height: "clamp(420px, 60vh, 640px)" }}
    >
      {showVideo ? (
        <video
          src={edition.video}
          poster={edition.poster || undefined}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={edition.media_type === "video" ? edition.poster : edition.image}
            alt={edition.image_alt || edition.title}
            loading="lazy"
            className="kenburns h-full w-full object-cover"
          />
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/75 via-charcoal/15 to-transparent" aria-hidden="true" />
      <div className="relative z-10 px-5 pb-10 lg:px-10 lg:pb-14 text-shadow-soft">
        <Reveal>
          <h2 className="h-condensed text-[clamp(2.25rem,5.5vw,4.5rem)]" data-testid="latest-edition-title">
            {edition.title}
          </h2>
          <p className="mt-2 text-sm font-light" data-testid="latest-edition-gallery">
            {edition.gallery}
          </p>
          {edition.external_url && (
            <a
              href={edition.external_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="latest-edition-learn-more"
              className="link-arrow mt-7 text-xs"
            >
              Learn More
              <CircledArrow className="h-5 w-5" />
            </a>
          )}
        </Reveal>
      </div>
    </section>
  );
};
